export const Routes = {
  NotLoggedIn: { path: "/", protected: false },
  Features: { path: "/features", protected: false },
  Solutions: { path: "/solutions", protected: false },
  Dashboard: {
    path: "/dashboard",
    protected: true,
    Emissions: {
      absolutePath: "/dashboard",
      path: ""
    },
    TimeReg: {
      absolutePath: "/dashboard/time-registration",
      path: "time-registration",
      RequestLogs: {
        absolutePath: "/dashboard/time-registration/logs",
        path: "logs"
      },
    },
    Allowance: {
      absolutePath: "/dashboard/allowance",
      path: "allowance"
    },
    Offices: {
      absolutePath: "/dashboard/offices",
      path: "offices"
    },
    Departments: {
      absolutePath: "/dashboard/departments",
      path: "departments"
    },
    Employees: {
      absolutePath: "/dashboard/employees",
      path: "employees"
    },
    Settings: {
      absolutePath: "/dashboard/settings",
      path: "settings",
      Billing: {
        PaymentInfo: {
          absolutePath: "/dashboard/settings/billing/info",
          path: "billing/info"
        },
        Invoices: {
          absolutePath: "/dashboard/settings/billing/invoices",
          path: "billing/invoices"
        }
      },
      Organization: {
        absolutePath: "/dashboard/settings/organization",
        path: "organization"
      }
    }
  },
  Signin: { path: "/sign-in", protected: false },
  Onboarding: { path: "/onboarding", protected: false },
  Pricing: { path: "/pricing", protected: false },
  ForgotPassword: { path: "/forgot-password", protected: false },
  ResetPassword: { path: "/reset-password", protected: false },
  NotFound: { path: "/404", protected: false },
  TermsAndConditions: { path: "/terms-and-conditions", protected: false },
  PrivacyPolicy: { path: "/privacy-policy", protected: false },
  AboutUs: { path: "/about-us", protected: false },
  Contact: { path: "/contact", protected: false },
  ContactSales: { path: "/contact-sales", protected: false },
  Partners: { path: "/partners", protected: false },
  KnowledgeBank: { path: "/knowledge-bank", protected: false },
  KnowledgeBankArticle: { path: "/knowledge-bank/:categoryId/:articleId", protected: false }
};

export { Link, useNavigate } from "react-router-dom";
